import React from "react";
import ConfigurationPanel from "./components/ConfigurationPanel";

export default function Configuration() {
  return (
    <div className="grid h-full min-h-0 grid-cols-1 gap-5">
      <ConfigurationPanel />
    </div>
  );
}


